import React from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';

/**
 * A column header styled like Settings → Client config's: the title, an optional second line
 * (e.g. "Required" over "Client"), and a tooltip explaining the column.
 */
export const FormFieldConfigColumnHeader = ({ title, subtitle, tooltip }) => (
	<Tooltip title={tooltip}>
		<Stack>
			<Typography variant='inherit' className='MuiDataGrid-columnHeader-Title'>
				{title}
			</Typography>
			{subtitle && <Typography variant='task_updated'>{subtitle}</Typography>}
		</Stack>
	</Tooltip>
);

FormFieldConfigColumnHeader.displayName = 'FormFieldConfigColumnHeader';
